import type {Dayjs} from 'dayjs'
import {formatLocalDate} from './formatLocalDate.ts'
import type {UserSettings} from '@package/shared'

export const formatLocalWeek = (date: Dayjs, userSettings: UserSettings): string => {
  return `${formatLocalDate(date.startOf('week'), userSettings)} - ${formatLocalDate(date.endOf('week'), userSettings)}`
}
